import React, { FC } from 'react';
import { IconProps } from '.';

export const CalendarIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.03 10.55H5.58a.48.48 0 0 0-.49.48v1.45c0 .27.22.49.49.49h1.45c.27 0 .49-.22.49-.49v-1.45a.48.48 0 0 0-.49-.48Zm-1.45-.61c-.6 0-1.1.49-1.1 1.09v1.45c0 .6.5 1.1 1.1 1.1h1.45c.6 0 1.1-.5 1.1-1.1v-1.45c0-.6-.5-1.1-1.1-1.1H5.58ZM12.73 10.55h-1.46a.48.48 0 0 0-.48.48v1.45c0 .27.22.49.48.49h1.46c.27 0 .48-.22.48-.49v-1.45a.48.48 0 0 0-.48-.48Zm-1.46-.61c-.6 0-1.09.49-1.09 1.09v1.45c0 .6.49 1.1 1.1 1.1h1.45c.6 0 1.09-.5 1.09-1.1v-1.45c0-.6-.49-1.1-1.1-1.1h-1.45ZM18.36 10.55h-1.45a.48.48 0 0 0-.49.48v1.45c0 .27.22.49.49.49h1.45c.27 0 .49-.22.49-.49v-1.45a.48.48 0 0 0-.49-.48Zm-1.45-.61c-.6 0-1.1.49-1.1 1.09v1.45c0 .6.5 1.1 1.1 1.1h1.45c.6 0 1.1-.5 1.1-1.1v-1.45c0-.6-.5-1.1-1.1-1.1h-1.45ZM7.03 15.88H5.58a.48.48 0 0 0-.49.48v1.46c0 .27.22.48.49.48h1.45c.27 0 .49-.21.49-.48v-1.46a.48.48 0 0 0-.49-.48Zm-1.45-.6c-.6 0-1.1.48-1.1 1.08v1.46c0 .6.5 1.09 1.1 1.09h1.45c.6 0 1.1-.49 1.1-1.1v-1.45c0-.6-.5-1.09-1.1-1.09H5.58ZM12.73 15.88h-1.46a.48.48 0 0 0-.48.48v1.46c0 .27.22.48.48.48h1.46c.27 0 .48-.21.48-.48v-1.46a.48.48 0 0 0-.48-.48Zm-1.46-.6c-.6 0-1.09.48-1.09 1.08v1.46c0 .6.49 1.09 1.1 1.09h1.45c.6 0 1.09-.49 1.09-1.1v-1.45c0-.6-.49-1.09-1.1-1.09h-1.45Z"
                clipRule="evenodd"
            />
            <path fill="currentColor" d="M2.97 6.73h5.15v.97H2.97v-.97Z" />
            <path fill="url(#04335ca6)" d="M8.12 6.73h12.85v.97H8.12v-.97Z" />
            <path
                fill="currentColor"
                d="M6.73 2.73a.73.73 0 0 1 1.45 0V4.3a.73.73 0 0 1-1.45 0V2.73ZM15.82 2.73a.73.73 0 0 1 1.45 0V4.3a.73.73 0 0 1-1.45 0V2.73ZM15.45 3.21h-6.9v.97h6.9v-.97Z"
            />
            <path
                fill="currentColor"
                d="M17.64 4.18h1.33c1.14 0 2.06.92 2.06 2.06v12.73c0 1.14-.92 2.06-2.06 2.06H5.03a2.06 2.06 0 0 1-2.06-2.06V6.24c0-1.14.92-2.06 2.06-2.06h1.33v-.97H5.03A3.03 3.03 0 0 0 2 6.24v12.73A3.03 3.03 0 0 0 5.03 22h13.94A3.03 3.03 0 0 0 22 18.97V6.24a3.03 3.03 0 0 0-3.03-3.03h-1.33v.97Z"
            />
            <defs>
                <linearGradient id="04335ca6" x1="8.12" x2="20.31" y1="7.21" y2="7.21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
